export const EXCMCARUSERDATA_SHOW_RESET = 'EXCMCARUSERDATA_SHOW_RESET'
export const EXCMCARUSERDATA_SHOW_SET_ERROR = 'EXCMCARUSERDATA_SHOW_SET_ERROR'
export const EXCMCARUSERDATA_SHOW_SET_RETRIEVED = 'EXCMCARUSERDATA_SHOW_SET_RETRIEVED'
export const EXCMCARUSERDATA_SHOW_TOGGLE_LOADING = 'EXCMCARUSERDATA_SHOW_TOGGLE_LOADING'
